import { Injectable } from '@angular/core';
import { UserService } from '@carm/_core/access-control-mgt/facade/user.service';
import { RolePermissionLoadingService } from '@carm/_core/role-type-permissions/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, take } from 'rxjs/operators';
import * as RolePermssionActions from '../actions/role-type-permission.actions';

@Injectable()
export class RoleTypePermissionEffects {

  constructor(private actions$: Actions,
              private userService: UserService,
              private rolePermissionLoading: RolePermissionLoadingService) {}

  loadPermission$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RolePermssionActions.loadPermissions),
      mergeMap(() => this.userService.getUserCurrentProgramId().pipe(take(1))),
      mergeMap( (programId: string) => {
            return this.rolePermissionLoading.getPermissions(programId).pipe(
              map((data) => RolePermssionActions.loadPermissionsSuccess({data})),
              catchError((error) => of(RolePermssionActions.loadPermissionsFailure({ error }))),
            );
        },
      ),
    );
  });

  loadNativePermission$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RolePermssionActions.loadNativeBusinessPermissions),
      mergeMap( (action) => {
            return this.rolePermissionLoading.getBusinessPermissions(action.data.businessId).pipe(
              map((data) => RolePermssionActions.loadNativeBusinessPermissionsSuccess({data})),
              catchError((error) => of(RolePermssionActions.loadNativeBusinessPermissionsFailure({ error }))),
            );

        },
      ),
    );
  });

}
